import { defineAction } from '~/prix'
import residenceImageConfirmAction from './residenceImageConfirm.action.json' with { type: 'json' }
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const residenceImageConfirmDefinition = defineAction({
  ...residenceImageConfirmAction,

  input: z.object({
    id: z.string().optional(),
    status: enumerated({
      pending: 'Pendente',
      success: 'Sucesso',
      failed: 'Falhou',
    }).optional(),
  }),
  output: z.object({}),
})

export default residenceImageConfirmDefinition
